import React, { useState } from 'react';
import Sidebar from '../components/layout/Sidebar';
import DashboardPage from '../components/pages/DashboardPage';
import DailyBusinessPage from '../components/pages/DailyBusinessPage';
import StockCheckPage from '../components/pages/StockCheckPage';
import LiterStatementPage from '../components/pages/LiterStatementPage';
import UsersPage from '../components/pages/UsersPage';
import CreateUserPage from '../components/pages/CreateUserPage';
import RolesPage from '../components/pages/RolesPage';
import ReportsPage from '../components/pages/ReportsPage';

const Dashboard = () => {
  const [activePage, setActivePage] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [navigationParams, setNavigationParams] = useState(null);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [usersRefreshKey, setUsersRefreshKey] = useState(0);

  const handleNavigate = (page, params = null) => {
    setNavigationParams(params);
    setActivePage(page);
  };

  // Clear navigation params when navigating back to dashboard
  const handlePageChange = (page) => {
    if (page === 'dashboard') {
      setNavigationParams(null);
    }
    setActivePage(page);
    // Reset sidebar visibility when navigating away from entry screens
    setHideSidebar(false);
  };

  // Determine if sidebar should be hidden
  const shouldHideSidebar = hideSidebar && (activePage === 'stock-check' || activePage === 'liter-statement');

  const renderPage = () => {
    switch (activePage) {
      case 'dashboard':
        return <DashboardPage onNavigate={handleNavigate} />;
      case 'daily-business':
        return <DailyBusinessPage navigationParams={navigationParams} onNavigationComplete={() => setNavigationParams(null)} />;
      case 'stock-check':
        return <StockCheckPage 
          navigationParams={navigationParams} 
          onNavigationComplete={() => setNavigationParams(null)}
          onViewChange={(isEntryMode) => setHideSidebar(isEntryMode)}
        />;
      case 'liter-statement':
        return <LiterStatementPage 
          navigationParams={navigationParams} 
          onNavigationComplete={() => setNavigationParams(null)}
          onViewChange={(isEntryMode) => setHideSidebar(isEntryMode)}
        />;
      case 'users':
        return <UsersPage key={usersRefreshKey} onNavigate={handleNavigate} />;
      case 'create-user':
        return <CreateUserPage onBack={() => {
          setUsersRefreshKey(prev => prev + 1);
          handlePageChange('users');
        }} />;
      case 'roles':
        return <RolesPage />;
      case 'reports':
        return <ReportsPage />;
      default:
        return <DashboardPage onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="flex h-dvh-screen bg-gradient-to-tr from-indigo-50/70 via-blue-50/50 to-purple-50/60">
      {!shouldHideSidebar && (
        <Sidebar
          activePage={activePage}
          setActivePage={handlePageChange}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
      )}

      <main className={`flex-1 overflow-y-auto transition-all duration-300 ${shouldHideSidebar ? 'md:ml-0' : (sidebarOpen ? 'md:ml-0' : 'md:ml-64')}`}>
        <div className="p-2 sm:p-3 md:p-4 pt-[max(0.5rem,env(safe-area-inset-top))] pb-[max(0.5rem,env(safe-area-inset-bottom))] pr-[max(0.5rem,env(safe-area-inset-right))] min-h-full">
          {/* Mobile Header */}
          <div className="md:hidden mb-4 sm:mb-6 flex items-center justify-between bg-white dark:bg-slate-800 rounded-xl sm:rounded-2xl p-3 sm:p-4 shadow-lg">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="p-2 rounded-xl hover:bg-slate-100 dark:hover:bg-slate-700 transition-all duration-300 btn-hover-scale"
              aria-label="Toggle sidebar"
            >
              <i className="fas fa-bars text-xl sm:text-2xl text-primary dark:text-accent"></i>
            </button>
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center">
                <i className="fas fa-chart-line text-white text-xs sm:text-sm"></i>
              </div>
              <span className="font-bold gradient-text text-sm sm:text-base">BizTracker</span>
            </div>

          </div>

          {renderPage()}
        </div>
      </main>

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 md:hidden transition-opacity duration-300"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
    </div>
  );
};

export default Dashboard;

